import { FC } from 'react';
import { connect } from 'react-redux';

import { CONTENT_FLOWS } from './_consts';
import ChatAiIntegration from './Integrations/ChatAiIntegration';
import ContentCreatorIntegration from './Integrations/ContentCreatorIntegration';
import HubDBIntegration from './Integrations/HubDBIntegration';
import HubSpotIntegration from './Integrations/HubSpotIntegration';
import SelectionFlow from './SelectionFlow';
import SetCsvSeparatorFlow from './SetCsvSeparatorFlow';
import TableFlow from './TableFlow';
import TextFileFlow from './TextFileFlow';
import TextFlow from './TextFlow';
import UploadErrorFlow from './UploadErrorFlow';
import UploadingFlow from './UploadingFlow';

interface IContent {
  contentFlow: string;
}

const Content: FC<IContent> = ({ contentFlow }) => {
  const ContentComponents = () => {
    switch (contentFlow) {
      case CONTENT_FLOWS.SELECTION:
        return (
          <>
            <SelectionFlow />
            <HubSpotIntegration />
            <HubDBIntegration />
            <ContentCreatorIntegration />
            <ChatAiIntegration />
          </>
        );
      case CONTENT_FLOWS.TEXT:
        return <TextFlow />;
      case CONTENT_FLOWS.UPLOADING:
        return <UploadingFlow />;
      case CONTENT_FLOWS.TEXT_FILE:
        return <TextFileFlow />;
      case CONTENT_FLOWS.TABLE:
        return <TableFlow />;
      case CONTENT_FLOWS.UPLOADING_ERROR:
        return <UploadErrorFlow />;
      case CONTENT_FLOWS.SETTING_CSV_SEPARATOR:
        return <SetCsvSeparatorFlow />;
      default:
        return null;
    }
  };

  return (
    <div className="ordering_form__content">
      <ContentComponents />
    </div>
  );
};

export default connect(({ contentFlow }) => ({ contentFlow }))(Content);
